
























































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import AjaxErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import ContactLensFKURepository from '@/models/item/fku/repository'
import ContactLensRootRepository from '@/models/item/root/repository'
import { UsualPowerService } from '@/services/api/usual-power/usual-power'
import AppId from '@/util/appid'
import { BrandRouteResolver } from '@/util/brandRouteResolver'
import { log } from '@/util/log'
import ContactLensCartIn from '@ajax/vue/components/organisms/contact-lens/CartIn.vue'
import ContactLensColorDropdown from '@ajax/vue/components/organisms/contact-lens/ColorDropdown.vue'
import ContactLensColorVariation from '@ajax/vue/components/organisms/contact-lens/ColorVariation.vue'
import ContactLensPowerLeftArea from '@ajax/vue/components/organisms/contact-lens/power/LeftArea.vue'
import ContactLensPowerRightArea from '@ajax/vue/components/organisms/contact-lens/power/RightArea.vue'
import ContactLensQuantityDropdown from '@ajax/vue/components/organisms/contact-lens/Quantity.vue'
import {
  fkuAdapterFromContactLensFku,
  publishEventForThirdParty,
  rootAdapterFromContactLensRoot,
} from '@ajax/vue/components/organisms/item-detail/publish-event-for-third-party'

import ContactLensItemDetailStore from './store'
import ContactLensItemDetailStoreBuilder from './store-builder'

@Component({
  components: {
    AjaxErrorDialog,
    ContactLensCartIn,
    ContactLensColorDropdown,
    ContactLensColorVariation,
    ContactLensPowerLeftArea,
    ContactLensPowerRightArea,
    ContactLensQuantityDropdown,
  },
})
export default class ContactLensUserSelectArea extends Vue {
  @Prop({ required: true })
  rootId: string

  @Prop({ default: null })
  initialSelectedColorName: string | null

  /*
   * #8687 displayPriceMode パラメータの取得
   * 'simple': 合計価格を非表示（Google Marchant Center向け
   * undefined: 合計価格を表示（デフォルト）
   */
  @Prop({ default: undefined })
  displayPriceMode: 'simple' | undefined

  store: ContactLensItemDetailStore | null = null

  /**
   * TODO: ストアビルダ側に状態を移したい。
   * しかしストアビルダ側の状態をこのコンポーネントで利用しようとしたところ、リアクティブに反映されなかったため、いったんコンポーネント側の状態管理としている。
   */
  isLoading: boolean = false

  hasApiError: boolean = false
  errorMessage: string[] = []

  async created() {
    try {
      this.isLoading = true

      const brandName = BrandRouteResolver.resolveBrandFromPathElement(this.$route.params.brand_english_name)
      const appId = AppId.getByBrandName(brandName)
      const behavior = BehaviorConfig.createFromBrand(brandName)

      this.store = await ContactLensItemDetailStoreBuilder.getInstance(
        new ContactLensRootRepository(appId),
        new ContactLensFKURepository(appId),
        new UsualPowerService()
      ).build(
        this.rootId,
        behavior,
        this.initialSelectedColorName
      )

      this.publishEventForThirdParty(this.store, behavior)
    } catch (error) {
      log.error('Store build failed:', error)
      this.hasApiError = true
      this.errorMessage = [
        '商品情報の読み込みに失敗しました。',
        '※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。',
      ]
    } finally {
      this.isLoading = false
    }
  }

  get hasError(): boolean {
    return !!this.store && this.store.hasUsualPowerServiceError
  }

  private publishEventForThirdParty(store: ContactLensItemDetailStore, behavior: BehaviorConfig): void {
    publishEventForThirdParty(
      rootAdapterFromContactLensRoot(store.root),
      store.fkus.map(fku => fkuAdapterFromContactLensFku(fku, behavior))
    )
  }
}
